/* eslint-disable no-plusplus */
import { doPost } from './apiUtils';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../shared/helper-utils/localStorage';

export const searchHotelsApi = async (req) => {
  try {
    const reqData = {
      ...req,
      searchQuery: {
        ...req.searchQuery,
        loggedInUserAgentId: getUserAgentId(),
      },
    };
    const request = {
      opid: 'HS000',
      actioncode: 'HSNEWV2',
      agentid: 'SUPER',
      data: JSON.stringify(reqData),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const searchHotelsByNameApi = async (req) => {
  try {
    const reqData = {
      ...req,
      searchQuery: {
        ...req.searchQuery,
        loggedInUserAgentId: getUserAgentId(),
      },
    };
    const request = {
      opid: 'HS000',
      actioncode: 'HNSEARCH',
      agentid: 'SUPER',
      responseformat: 'html',
      data: JSON.stringify(reqData),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getRecentCities = async () => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'POPULARSECTOR',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelCitiesApi = async (searchKey) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'HSGENERIC',
      agentid: 'SUPER',
      responseformat: 'html',
      data: JSON.stringify({
        inputData: { city: searchKey },
        action: 'get_cities',
      }),
    };
    let response = await doPost(request);
    response = Array.isArray(response) ? response : [response];
    return response.filter(
      (cityNode) =>
        cityNode.city !== '' &&
        cityNode.city !== null &&
        cityNode.city !== undefined,
    );
  } catch (error) {
    return [];
  }
};

export const getHotelDetailsApi = async (req) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'HSDETAILSNEW',
      agentid: getUserAgentId(),
      data: JSON.stringify(req),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelBookingsApi = async (fromDate, toDate) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'BOOKINGHISTORY',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      fromdate: fromDate,
      todate: toDate,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelBookingDetailsApi = async (transactionId) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'HS005',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      txid: transactionId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelVoucherDetailsApi = async (transactionId) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'HSETICKET',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      txid: transactionId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const bookHotelApi = async (
  req,
  agentId,
  bankid,
  paymentmode,
  pgname,
) => {
  try {
    const string = JSON.stringify(req);
    const base64 = btoa(string);
    const request = {
      opid: 'TX047',
      actioncode: 'nextrahotelsnewv2',
      agentid: agentId,
      data: base64,
      bankid,
      isCustomerbilling: true,
      responseformat: 'JSON',
      uniquetimestamp: new Date().getTime(),
      paymentmode,
      pgname,
      isenc: true,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const holdHotelApi = async (req, agentId, paymentmode) => {
  try {
    const jsonString = JSON.stringify(req);
    const base64 = btoa(jsonString);
    const request = {
      opid: 'TX047',
      actioncode: 'nextrahotelsholdv2',
      agentid: agentId,
      data: base64,
      isCustomerbilling: true,
      uniquetimestamp: new Date().getTime(),
      paymentmode,
      isenc: true,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelPaxCalendarApi = async (agentid, calmonth, calyear) => {
  try {
    const request = {
      agentid,
      opid: 'RP006',
      resultformat: 'JSON',
      actioncode: 'HOTELPAXCAL',
      calmonth,
      calyear,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getConversionRate = async (agentid, option) => {
  try {
    const request = {
      agentid,
      opid: 'HS000',
      actioncode: 'HSGENERIC',
      responseformat: 'html',
      data: JSON.stringify({
        inputData: {
          fromCurrency: getValueFromAppConfig('SAAS_APP_CURRENCY'),
          toCurrency: option,
          clientId: getValueFromAppConfig('SAASDBNAME'),
        },
        action: 'get_conv_rate',
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const emailHotelOptions = async (content) => {
  const agentid = getUserAgentId();
  const req = {
    opid: 'HS000',
    actioncode: 'HSGENERIC',
    responseformat: 'html',
    agentid,
    data: content,
  };
  const response = await doPost(req);
  return response;
};

export const offlineHotelCancellation = async (reqObj) => {
  const req = {
    opid: 'HS000',
    actioncode: 'HOTELCANXREQUESTOFFLINE',
    resultformat: 'JSON',
    ...reqObj,
  };
  const response = await doPost(req);
  return response;
};

export const getWeatherForLocation = async (lat, lon) => {
  try {
    const req = {
      opid: 'FS000',
      actioncode: 'WEATHERV2',
      airportcode: 'AAA',
      resultformat: 'JSON',
      lat,
      lon,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const cancelHotelBookingApi = async (txid) => {
  try {
    const agentid = getUserAgentId();
    const req = {
      opid: 'HS000',
      actioncode: 'HOTELCANCEL',
      txid,
      agentid,
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const validateHotelPricingApi = async (request) => {
  try {
    const req = {
      opid: 'HS000',
      actioncode: 'REPRICEV2',
      resultformat: 'html',
      agentid: getUserAgentId(),
      data: JSON.stringify(request),
    };
    const res = await doPost(req);
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getRoomCancellationRulesApi = async (request) => {
  try {
    const req = {
      opid: 'HS000',
      actioncode: 'HSGENERIC',
      responseformat: 'html',
      agentid: getUserAgentId(),
      data: JSON.stringify(request),
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getHotelResultsForHotelName = async (hotelname) => {
  try {
    const req = {
      opid: 'HS000',
      actioncode: 'HSGENERIC',
      responseformat: 'html',
      agentid: getUserAgentId(),
      data: JSON.stringify({
        inputData: { hotelname },
        action: 'get_hotel_names',
      }),
      resultformat: 'JSON',
    };
    let response = await doPost(req);
    response = Array.isArray(response) ? response : [response];
    return response.filter(
      (cityNode) =>
        cityNode.hotelname !== '' &&
        cityNode.hotelname !== null &&
        cityNode.hotelname !== undefined,
    );
  } catch (error) {
    return [];
  }
};

export const performHotelTicketing = async (txid, paymentmode) => {
  try {
    const req = {
      opid: 'TX047',
      actioncode: 'nextrahotelsreconfirm',
      txid,
      paymentmode,
      mandatorydata: '',
      resultformat: 'JSON',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getHotelCancellationsApi = async (fromDate, toDate) => {
  try {
    const request = {
      opid: 'RP030',
      actioncode: 'GETHOTELCANXHISTORYUSER',
      agentid: getUserAgentId(),
      resultformat: 'JSON',
      fromdate: fromDate,
      todate: toDate,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getHotelCancellationDetailsApi = async (txid) => {
  try {
    const request = {
      opid: 'RP030',
      actioncode: 'HOTELCANXDETAIL',
      resultformat: 'JSON',
      txid,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getCitiesApiV2 = async (searchKey) => {
  try {
    const res = await fetch(
      `https://www.gtdsonline.com/googleplaces.jsp?actionname=autotextsearchgoogle&isArray=false&latitude=&longitude=&placeid=&query=&searchkey=${searchKey}&service=hotelsearchgoogle&timeout=30000`,
      {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      },
    );
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getLatLngApiV2 = async (placeId, value) => {
  try {
    const res = await fetch(
      `https://www.gtdsonline.com/googleplaces.jsp?actionname=placedetails&authtoken=&isArray=false&latitude=&longitude=&placeid=${placeId}&query=&searchkey=${value}&service=hotelsearchgoogle&timeout=30000`,
      {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      },
    );
    return res;
  } catch (error) {
    return undefined;
  }
};

export const getHotelDetailsApiV2 = async (req) => {
  try {
    const request = {
      opid: 'HS000',
      actioncode: 'HSDETAILSV2',
      agentid: getUserAgentId(),
      data: JSON.stringify(req),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const calculateAge = (birthDateStr, checkInDateStr) => {
  const birthDate = new Date(birthDateStr);
  const checkInDate = new Date(checkInDateStr);

  let age = checkInDate.getFullYear() - birthDate.getFullYear();

  // Adjust if the check-in date is before the birth date in the check-in year
  if (
    checkInDate.getMonth() < birthDate.getMonth() ||
    (checkInDate.getMonth() === birthDate.getMonth() &&
      checkInDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};
